import { memo } from "react";

import { useTransactionData } from "app/components/transactions";

import { useMarketContext } from "../common";
import { useMarketLendContext } from "./MarketLendContext";
import { BalanceDisplay, TokenInputWithPrice, useBalanceChecker } from "../../common";
import { useSelectMarketPrincipal } from "../util";
import { getTransactionTypeFromYieldSource } from "./util";

export default memo(function LendAmount() {
    const { token, principalMint } = useMarketContext();
    const selectPrincipal = useSelectMarketPrincipal();
    const {
        form: { amount, yieldSource },
        setForm
    } = useMarketLendContext();
    const { getTransactionFees } = useTransactionData();

    const { balance, insufficientBalance, isLoading } = useBalanceChecker({
        mint: principalMint,
        amount,
        solanaFeeBuffer: getTransactionFees(getTransactionTypeFromYieldSource(yieldSource)).totalFeeAmount
    });

    return (
        <TokenInputWithPrice
            label="You supply"
            labelColor="body"
            autoFocus
            selectToken={selectPrincipal}
            metadata={token}
            belowInput={
                <BalanceDisplay
                    balance={balance}
                    insufficientBalance={insufficientBalance}
                    isLoading={isLoading}
                    metadata={token}
                    setMax={(amount) => setForm((prev) => ({ ...prev, amount }))}
                />
            }
            value={amount}
            setValue={(amount) => setForm((prev) => ({ ...prev, amount }))}
        />
    );
});
